module.exports = __webpack_public_path__ + "static/img/newFood1.5040d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood1.png
// module id = +zXr
// module chunks = 2